
import { Vue, Options } from 'vue-class-component';
import MoreInfoButton from '@/components/shared/more-info-button.vue';
import {reactive, ref} from 'vue';

@Options({
  components: {MoreInfoButton},
  props: ['itemData','curbs', 'scarp', 'grout', 'impregnation', 'addon'],
  data() {
    return {
      itemAdded: this.itemData['itemAdded'] || false,
      inputValue: this.itemData['inputValue'] || null,
      impregnationFactor: [],
      groutFactor: []
    }
  },
  setup(){
    const formRef = ref();

    const formState = reactive({
      quantity: undefined
    });

    return {
      formRef,
      formState
    }
  },
  watch: {
    inputValue(x){
      if(this.impregnation){
        let quantity = 0;
        (this.impregnationFactor || []).forEach(i => {
          quantity = x * i / this.itemData.attributes.kolicina_enot;
        })
        this.itemData.quantity = Math.ceil(quantity);
        this.itemData.inputValue = x;
      }
      if(this.grout){
        let quantity = 0;
        (this.groutFactor || []).forEach(i => {
          quantity = x * i / this.itemData.attributes.kolicina_enot;
        })
        this.itemData.quantity = Math.ceil(quantity);
        this.itemData.inputValue = x;
      }
    }
  },
  mounted(){
    if(this.grout){
      const selectedTiles = this.$store.state.selectedTiles;

      if((selectedTiles || []).length > 0) {
        let value = 0;
        let groutFactor = [];
        selectedTiles.forEach(x => {
          groutFactor.push(x.attributes.faktor_fugirna_masa || 3)
          value += x.quantity
        })

        this.inputValue = this.itemData.itemAdded ? this.itemData.inputValue : value;
        this.groutFactor = groutFactor;
      }
    }
    if(this.impregnation){
      const selectedTiles = this.$store.state.selectedTiles;

      if((selectedTiles || []).length > 0) {
        let value = 0;
        let impregnationFactor = [];
        selectedTiles.forEach(x => {
          impregnationFactor.push(x.attributes.faktor_impregnacija || 0.17)
          value += x.quantity;
        })

        this.inputValue = this.itemData.itemAdded ? this.itemData.inputValue : value;
        this.impregnationFactor = impregnationFactor;
      }
    }
    if(this.itemData.key === "400201"){
      const selectedTiles = this.$store.state.selectedTiles;
      if((selectedTiles || []).length > 0) {
        let value = 0;
        selectedTiles.forEach(x => {
          value += x.quantity;
        })
        if(value % 25 !== 0){
          value = Math.ceil(value / 25) * 25;
        }
        this.itemData.quantity = value;
      }
    }
  },
  methods: {
    buttonChange(e){
      this.itemAdded = parseFloat(e.target.value) ? true : false;
      this.itemData.itemAdded = this.itemAdded;
    },
    buttonBlur(e){
      if(this.itemData.key === "400201"){
        if(e.target.value % 25 !== 0){
          this.itemData.quantity = Math.ceil(this.itemData.quantity / 25) * 25;
          e.target.value = this.itemData.quantity;
        }
      }
    },
    addItem(x: boolean) {
      if(!this.itemData.quantity){
        this.$refs.quantity.focus();
      }
      else {
        this.$refs.formRef
            .validate()
            .then(() => {
              this.itemAdded = x;
              this.itemData.itemAdded = this.itemAdded;
            })
      }
    },
    async validateArea(r, v) {
      if (parseFloat(v) > 0) {
        return Promise.resolve();
      } else {
        this.itemAdded = false;
        this.itemData.itemAdded = false;
        if(v){
          return Promise.reject('Vrednost mora biti večja od 0!');
        }
      }
    }
  }
})

export default class AddonCard extends Vue {
}

